import React from "react";
import GetInTouch from "../Components/contact/getInTouch";

export default function Contact() {
    return (
        <div>
            <GetInTouch />
        </div>
    );
}
